/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useState, useEffect} from 'react'
import Table from 'react-bootstrap/Table'
import Button from 'react-bootstrap/Button'
import {PageTitle} from '../../../../_metronic/layout/core'
import Form from 'react-bootstrap/Form'
import {Col, Dropdown, Modal, Row, Spinner} from 'react-bootstrap'
import Pagination from 'react-bootstrap/Pagination'
import usePagination from 'utils/hooks/usePagination'
import {Link, useNavigate} from 'react-router-dom'
import useServices from '../../../../utils/hooks/useServices'
import useDebounce from '../../../../utils/hooks/useDebounce'
import MasterServices from '../../../../services/master'
import {toast} from 'react-toastify'
import FormGenerator from '../../../../utils/helpers/FormGenerator'

let active = 1
let items: any = []
for (let number = 1; number <= 5; number++) {
  items.push(
    <Pagination.Item key={number} active={number === active}>
      {number}
    </Pagination.Item>
  )
}

const heads = [
  {
    name: '',
    label: 'Nama Alumni',
  },
  {
    name: '',
    label: 'Email',
  },
  {
    label: 'Status',
  },
  {
    name: '',
    label: 'Aksi',
  },
]

const UserPage: FC = () => {
  let navigate = useNavigate()
  const [pagination, setPagination] = useState({
    per_page: 10,
    page: 1,
    total_page: 1,
    total_page_arr: [1, 2, 3, 4, 5],
    total_row: 10,
  })
  const [filter, setFilter] = useState<any>({})
  const [show, setShow] = useState(false)
  const [query, setQuery] = useState<any>({q: '', sort_order: 'desc'})
  const [formValue, setFormValue] = useState<any>({status: '', company_id: ''})
  const [submit, setSubmit] = useState(false)
  const [showFilter, setShowFilter] = useState(false)
  const [loadingMaster, setLoadingMaster] = useState<boolean>(false)
  const [selected, setSelected] = useState<any>([])
  const [counter, setCounter] = useState(1)
  const [data, loading, empty, refresh, isError, setLoading] = useServices(
    MasterServices.getAlumniHash,
    {
      ...query,
      page: pagination.page,
      sort_field: 'created_at',
      per_page: pagination.per_page,
      roles: ['alumni'],
      status: [1, 5],
      skill_id: filter?.skill_id,
      experience: filter?.experience,
      gender: filter?.gender,
      degree_id: filter?.degree_id,
      major_id: filter?.major_id,
      university_id: filter?.university_id,
      min_age: filter?.min_age,
      max_age: filter?.max_age,
      city_id: filter?.city_id,
      industry_id: filter?.industry_id,
      language_id: filter?.language_id,
    },
    []
  )

  const [lastSyncAlumniJob, loadingSync, emptySync, refreshSync, isErrorSync, setLoadingSync] =
    useServices(MasterServices.getLastSyncAlumniJob, {}, [])

  useEffect(() => {
    fetchSkill()
    fetchDegree()
    fetchMajor()
    fetchUniversity()
    fetchCity()
    fetchIndustry()
    fetchLanguage()
  }, [])

  const paginator: any = usePagination({
    totalCount: data?.data?.total,
    pageSize: pagination.per_page || 10,
    currentPage: pagination.page || 1,
  })

  const [inputs, setInputs] = useState<any>([
    {
      name: 'skill_id',
      label: 'Keahlian',
      type: 'select2',
      validation: {},
      col: 12,
      options: [],
      additional: '',
      getItemValue: 'skills_name',
      getItemValueId: 'skills_id',
    },
    {
      name: 'experience',
      label: 'Lama Pengalaman Kerja',
      type: 'number',
      validation: {},
      col: 3,
      options: [],
      additional: '',
      getItemValue: 'experience',
      getItemValueId: 'experience',
    },
    {
      name: 'gender',
      label: 'Jenis Kelamin',
      type: 'select',
      validation: {},
      col: 3,
      options: [
        {
          name: 'Pilih Jenis Kelamin',
          value: '',
        },
        {
          name: 'Pria',
          value: '1',
        },
        {
          name: 'Wanita',
          value: '0',
        },
      ],
      getItemValue: 'name',
      getItemValueId: 'value',
      additional: '',
    },
    {
      name: 'degree_id',
      label: 'Jenjang Pendidikan',
      type: 'select2',
      validation: {},
      col: 6,
      options: [],
      additional: '',
      getItemValue: 'degrees_name',
      getItemValueId: 'degrees_id',
    },
    {
      name: 'major_id',
      label: 'Jurusan',
      type: 'select2',
      validation: {},
      col: 6,
      options: [],
      additional: '',
      getItemValue: 'majors_name',
      getItemValueId: 'majors_id',
    },
    {
      name: 'university_id',
      label: 'Universitas',
      type: 'select2',
      validation: {},
      col: 6,
      options: [],
      additional: '',
      getItemValue: 'universities_name',
      getItemValueId: 'universities_id',
    },
    {
      name: 'min_age',
      label: 'Usia Minimum',
      type: 'number',
      validation: {},
      col: 3,
      options: [],
      additional: '',
      getItemValue: 'min_age',
      getItemValueId: 'min_age',
    },
    {
      name: 'max_age',
      label: 'Usia Maksimum',
      type: 'number',
      validation: {},
      col: 3,
      options: [],
      additional: '',
      getItemValue: 'max_age',
      getItemValueId: 'max_age',
    },
    {
      name: 'city_id',
      label: 'Lokasi',
      type: 'select2',
      validation: {},
      col: 6,
      options: [],
      additional: '',
      getItemValue: 'cities_name',
      getItemValueId: 'cities_id',
    },
    {
      name: 'industry_id',
      label: 'Industry',
      type: 'select2',
      validation: {},
      col: 6,
      options: [],
      additional: '',
      getItemValue: 'industries_name',
      getItemValueId: 'industries_id',
    },
    {
      name: 'language_id',
      label: 'Bahasa',
      type: 'select2',
      validation: {},
      col: 6,
      options: [],
      additional: '',
      getItemValue: 'languages_name',
      getItemValueId: 'languages_id',
    },
  ])

  useEffect(() => {
    refresh()
    generateTotalPage(pagination.total_page)
  }, [pagination.per_page, pagination.page])

  useDebounce(refresh, 250, [query.q, query.sort_order])

  useEffect(() => {
    refresh()
    generateTotalPage(pagination.total_page)
    setShowFilter(false)
  }, [filter])

  const fetchSkill = async (q = '') => {
    setLoadingMaster(true)
    await MasterServices.getSkill({...{is_active: 1}, q})
      .then((response) => {
        const {data} = response.data
        inputs[0].options = data
        setInputs(inputs)
        setLoadingMaster(false)
      })
      .catch((err) => {
      })
  }

  const fetchDegree = async (q = '') => {
    setLoadingMaster(true)
    await MasterServices.getDegree({...{is_active: 1}, q})
      .then((response) => {
        const {data} = response.data
        inputs[3].options = data
        setInputs(inputs)
        setLoadingMaster(false)
      })
      .catch((err) => {
      })
  }

  const fetchMajor = async (q = '') => {
    setLoadingMaster(true)
    await MasterServices.getMajor({...{is_active: 1}, q})
      .then((response) => {
        const {data} = response.data
        inputs[4].options = data
        setInputs(inputs)
        setLoadingMaster(false)
      })
      .catch((err) => {
      })
  }

  const fetchUniversity = async (q = '') => {
    setLoadingMaster(true)
    await MasterServices.getUniversity({...{is_active: 1}, q})
      .then((response) => {
        const {data} = response.data
        inputs[5].options = data
        setInputs(inputs)
        setLoadingMaster(false)
      })
      .catch((err) => {
      })
  }

  const fetchCity = async (q = '') => {
    setLoadingMaster(true)
    await MasterServices.getCity({...{is_active: 1}, q})
      .then((response) => {
        const {data} = response.data
        inputs[8].options = data
        setInputs(inputs)
        setLoadingMaster(false)
      })
      .catch((err) => {
      })
  }

  const fetchIndustry = async (q = '') => {
    setLoadingMaster(true)
    await MasterServices.getIndustry({...{is_active: 1}, q})
      .then((response) => {
        const {data} = response.data
        inputs[9].options = data
        setInputs(inputs)
        setLoadingMaster(false)
      })
      .catch((err) => {
      })
  }

  const fetchLanguage = async (q = '') => {
    setLoadingMaster(true)
    await MasterServices.getLanguage({...{is_active: 1}, q})
      .then((response) => {
        const {data} = response.data
        inputs[10].options = data
        setInputs(inputs)
        setLoadingMaster(false)
      })
      .catch((err) => {
      })
  }

  const handleFilter = () => {
    setFilter({
      skill_id: formValue?.skill_id?.skills_id ? [formValue?.skill_id?.skills_id] : [],
      experience: formValue?.experience,
      gender: formValue?.gender,
      degree_id: formValue?.degree_id?.degrees_id ? [formValue?.degree_id?.degrees_id] : [],
      major_id: formValue?.major_id?.majors_id ? [formValue?.major_id?.majors_id] : [],
      university_id: formValue?.university_id?.universities_id
        ? [formValue?.university_id?.universities_id]
        : [],
      min_age: formValue?.min_age,
      max_age: formValue?.max_age,
      city_id: formValue?.city_id?.cities_id ? [formValue?.city_id?.cities_id] : [],
      industry_id: formValue?.industry_id?.industries_id
        ? [formValue?.industry_id?.industries_id]
        : [],
      language_id: formValue?.language_id?.languages_id
        ? [formValue?.language_id?.languages_id]
        : [],
    })
  }

  const onKeyUp = (input: any, value: any, key: any) => {
    const name = input
    switch (name) {
      case 'skill_id':
        fetchSkill(value)
        break
      case 'degree_id':
        fetchDegree(value)
        break
      case 'major_id':
        fetchMajor(value)
        break
      case 'university_id':
        fetchUniversity(value)
        break
      case 'city_id':
        fetchCity(value)
        break
      case 'industry_id':
        fetchIndustry(value)
        break
      case 'language_id':
        fetchLanguage(value)
        break
    }
  }

  const handleReset = () => {
    setFormValue({})
  }

  const StatusComponent = (type: string, obj?: any) => {
    // return <Button variant='info'>{type}</Button>
    if (type === '0') {
      return (
        <Button
          variant='info'
          onClick={() => {
            setFormValue({
              ...formValue,
              status: obj.companies_status,
              company_id: obj.companies_id,
            })
            toggle()
          }}
        >
          Verifikasi 1
        </Button>
      )
    }
    if (type === '1') {
      return (
        <Button
          variant='success'
          className='shadow-none btn btn-sm btn-outline btn-outline-success'
          onClick={() => {
            setFormValue({
              ...formValue,
              status: obj.companies_status,
              company_id: obj.companies_id,
            })
            toggle()
          }}
        >
          Aktif
        </Button>
      )
    }
    if (type === '5') {
      return (
        <Button
          variant='danger'
          onClick={() => {
            setFormValue({
              ...formValue,
              status: obj.companies_status,
              company_id: obj.companies_id,
            })
            toggle()
          }}
          className='shadow-none btn btn-sm btn-outline btn-outline-dark'
        >
          Non-Aktif
        </Button>
      )
    }
    if (type === '3') {
      return (
        <Button
          variant='secondary'
          onClick={() => {
            setFormValue({
              ...formValue,
              status: obj.companies_status,
              company_id: obj.companies_id,
            })
            toggle()
          }}
        >
          Blokir
        </Button>
      )
    }
  }

  const handleApprove = async () => {
    try {
      setSubmit(true)
      await MasterServices.approveCompany(formValue)
      toast.success('Proses berhasil dilakukan')
      refresh()
    } catch (error) {
    } finally {
      setSubmit(false)
    }
  }

  const toggle = () => {
    if (show) {
      setFormValue({})
    }
    setShow(!show)
  }

  const generateTotalPage = (totalPage: number) => {
    let total = 0
    let newTotal: any = []

    for (total = 0; total < totalPage; total++) {
      if (total < 4) {
        newTotal.push(total + 1)
      } else if (total === 8) {
        newTotal.push('...')
        newTotal.push(totalPage)
      }
    }
    return newTotal
  }
  const onChangePerPage = (per_page: number, to_page = 1) => {
    setPagination({
      ...pagination,
      per_page: per_page,
      page: to_page || 1,
    })
  }

  const handleSync = async () => {
    if (lastSyncAlumniJob?.data?.is_in_sync == 1) {
      toast.error(`Already Requested Sync Data`)
      return
    }

    try {
      setLoading(true)
      await MasterServices.syncAlumniJob()
      toast.success(`Requested Sync Data`)
      refreshSync()
      refresh()
    } catch (error) {
    }
  }

  const handleChangeStatus = async () => {
    try {
      if (window.confirm('Yakin ingin Mengubah status Alumnii ?')) {
        setLoading(true)
        for (let index = 0; index < selected.length; index++) {
          const element = selected[index]
          await MasterServices.approveCompany(element)
        }
        toast.success(`Status Alumni Berhasil Diperbarui`)
      }
    } catch (error) {
    } finally {
      refresh()
    }
  }

  const handleChangeStatusSingle = async (id: any, status: any) => {
    try {
      if (window.confirm('Yakin ingin Mengubah status Alumni ?')) {
        setLoading(true)
        await MasterServices.updateStatusUser({status: status, user_id: id, id: id})
        toast.success(`Status Alumni Berhasil Diperbarui`)
      }
    } catch (error) {
    } finally {
      refresh()
    }
  }

  const onChange = (e: any) => {
    setFormValue({
      ...formValue,
      [e.target.name]: e.target.value,
    })
  }

  const toggleFilter = () => setShowFilter(!showFilter)
  return (
    <>
      <div className='row'>
        <Modal show={showFilter} onHide={toggleFilter} size='lg'>
          <Modal.Header closeButton>
            <Modal.Title>Filter</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>{FormGenerator(inputs, formValue, onChange, onKeyUp)}</Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant='secondary' onClick={() => handleReset()}>
              Reset
            </Button>
            <Button onClick={() => handleFilter()}>Simpan</Button>
          </Modal.Footer>
        </Modal>
        <Modal show={false} onHide={toggle} size='lg'>
          <Modal.Header closeButton>
            <Modal.Title>Verifikasi Alumni</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row>
                <Col md={12}>
                  <Form.Label>Status</Form.Label>
                  <Form.Select
                    onChange={(e: any) => setFormValue({...formValue, status: e.target.value})}
                  >
                    {[
                      {name: 'Verifikasi 1', value: '0'},
                      {name: 'Aktif', value: '1'},
                      {name: 'Ditolak', value: '2'},
                      {name: 'Tutup', value: '3'},
                    ].map((item, key) => {
                      return (
                        <option
                          key={key}
                          value={item.value}
                          selected={formValue.status === item.value}
                        >
                          {item.name}
                        </option>
                      )
                    })}
                  </Form.Select>
                </Col>
              </Row>
              <Modal.Footer>
                <Button variant='secondary' onClick={toggle} disabled={submit}>
                  Batalkan
                </Button>
                <Button variant='primary' disabled={submit} onClick={handleApprove}>
                  {submit ? 'Loading' : 'Simpan'}
                </Button>
              </Modal.Footer>
            </Form>
          </Modal.Body>
        </Modal>
        <div className='col-md-12'>
          <div className='card-custom' style={{paddingBottom: '80px'}}>
            <Row>
              <Col md={{span: 4}}>
                <Form.Control
                  placeholder='Cari...'
                  name='q'
                  onChange={(e) => setQuery({...query, q: e.target.value})}
                />
              </Col>
              <Col md={{span: 2}} />
              <Col md={{span: 2}}>
                <Button
                  type='button'
                  variant='secondary'
                  onClick={() => handleSync()}
                  className='form-control'
                >
                  Sync Queue
                </Button>
              </Col>
              <Col md={{span: 2}}>
                <Button type='button' onClick={toggleFilter} className='form-control'>
                  Filter
                </Button>
              </Col>
              <Col md={{span: 2}}>
                <Form.Select
                  aria-label='Default select example'
                  className='mr-8'
                  onChange={(e) => {
                    setQuery({...query, sort_order: e.target.value})
                  }}
                >
                  <option value='desc'>Terbaru</option>
                  <option value='asc'>Terlama</option>
                </Form.Select>
              </Col>
            </Row>
            {selected.length > 0 && (
              <Button onClick={handleChangeStatus} type='button' className='mt-8'>
                Approve data terpilih ?
              </Button>
            )}
            <Row md={12} className='mt-8'>
              {lastSyncAlumniJob?.data ? (
                <>
                  <p>
                    Last Request Sync:{' '}
                    {new Date(lastSyncAlumniJob?.data?.created_at).toLocaleString() || '-'}
                  </p>
                  {lastSyncAlumniJob?.data?.is_in_sync == 1 ? <p>Process Sync data...</p> : ''}
                </>
              ) : null}

              <Table responsive className='table-striped align-middle'>
                <thead>
                  <tr>
                    <th>#</th>
                    {heads.map((item, index) => (
                      <th key={index} style={{maxWidth: item.label == 'Aksi' ? '100px' : ''}}>
                        {item.label}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {data.data?.data?.length === 0 && !loading && (
                    <tr>
                      <td colSpan={5} align='center'>
                        Tidak ada Data
                      </td>
                    </tr>
                  )}
                  {loading ? (
                    <tr>
                      <td colSpan={5} align='center'>
                        <Spinner
                          animation='border'
                          role='status'
                          style={{height: '100px', width: '100px'}}
                        />
                      </td>
                    </tr>
                  ) : (
                    counter &&
                    data.data?.data?.map((item: any, key: any) => {
                      return (
                        <tr key={key}>
                          <td>{key + 1}</td>
                          <td>
                            <Link
                              to={`/crafted/pages/profile/basic-overview?alumni=${item.users_id}`}
                            >
                              {item.fullname}
                            </Link>
                          </td>
                          {/* <td>{new Date(item.created_at).toLocaleDateString() || '-'}</td> */}
                          <td>{item.email || '-'}</td>
                          {/* <td>{item.users_username || '-'}</td> */}
                          <td>{StatusComponent(item.users_status)}</td>
                          <td>
                            <Dropdown>
                              <Dropdown.Toggle
                                id='dropdown-basic'
                                className='btn btn-primary btn-sm'
                              >
                                {'  '}
                                Aksi
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                <Dropdown.Item
                                  onClick={() => {
                                    // setFormValue({
                                    //   id: item.companies_id,
                                    //   name: item.companies_name,
                                    //   description: item.companies_description,
                                    // })
                                    // toggle()
                                    navigate(
                                      `/crafted/pages/profile/basic-overview?alumni=${item.users_id}`
                                    )
                                  }}
                                >
                                  Lihat
                                </Dropdown.Item>
                                {/* {item.users_status == '1' && ( */}
                                <Dropdown.Item
                                  onClick={() =>
                                    handleChangeStatusSingle(
                                      item.users_id,
                                      item.users_status == '1' ? '5' : '1'
                                    )
                                  }
                                >
                                  {item.users_status == '5' ? 'Aktifkan' : 'Non-Aktifkan'}
                                </Dropdown.Item>
                                {/* )} */}
                              </Dropdown.Menu>
                            </Dropdown>
                          </td>
                        </tr>
                      )
                    })
                  )}
                </tbody>
              </Table>
            </Row>
            <Row>
              <Col md={6}>
                {data?.data?.data?.length > 0 && !loading && (
                  <div style={{float: 'left'}}>
                    <Dropdown>
                      <Dropdown.Toggle className='btn btn-sm'>
                        {pagination.per_page}
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {[10, 25, 50, 100].map((item: any) => (
                          <Dropdown.Item
                            key={item}
                            href='#/action-1'
                            onClick={() => onChangePerPage(item)}
                            disabled={pagination.per_page === item}
                          >
                            {item}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                )}
              </Col>
              <Col md={6}>
                <div style={{float: 'right'}}>
                  {!loading && (
                    <Pagination className='btn-sm'>
                      {paginator?.map((item: any) => {
                        return (
                          <Pagination.Item
                            className='btn-sm'
                            key={item}
                            active={item === pagination.page}
                            onClick={() => onChangePerPage(pagination.per_page, item)}
                            disabled={item === '...'}
                          >
                            {item}
                          </Pagination.Item>
                        )
                      })}
                    </Pagination>
                  )}
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </>
  )
}

const User: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            title: 'Dashboard',
            path: '/dashboard',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '/',
            path: '',
            isSeparator: false,
            isActive: false,
          },
        ]}
      >
        Semua Alumni
      </PageTitle>
      <UserPage />
    </>
  )
}

export default User
